<template>
    <sweet-modal icon="warning" ref="deletePostModal" @close="$emit('modal-close')">
        <div v-if="selected !== null" class="text-center">
            <p class="mt-3" v-html="$t('pages.admin.blog.index.delete_confirmation', {title: selected.title})"></p>
            <button class="btn btn-danger" @click="deleteSelected">
                {{ $t('actions.delete') }}
            </button>
        </div>
    </sweet-modal>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue'
import AdminBlogRepository from "../../../repositories/Admin/AdminBlogRepository";
export default {
    name: "BlogDeleteModal",
    components: {SweetModal},
    props: {
        selected: {
            type: Object,
            default: null
        }
    },
    methods: {
        deleteSelected() {
            AdminBlogRepository
                .deletePost(this.selected.id)
                .then((res) => {
                    this.$emit('post-deleted');
                    this.$refs.deletePostModal.close();
                });
        }
    },
    watch: {
        selected: function (val) {
            if(val !== null)
                this.$refs.deletePostModal.open();
        }
    }
}
</script>

<style scoped>

</style>
